export const DAS_FINTECH_ORG_MANAGER = 'Michael DeGard';

export const DAS_FINTECH_ORG_MANAGER_ALIAS = 'degardm';
